module.exports = __webpack_public_path__ + "assets/media/yellow-splatter-large.d35268f3.png";